export const UPDATE_MODE = "UPDATE_MODE"

export const updateMode = (mode) => dispatch => {
    return dispatch({ type: UPDATE_MODE, mode });
}
